module.exports = __webpack_public_path__ + "img/finish.7cea44bf.png";